// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3ckBN","actions":"GroupTable_actions__doGxC","deleteModalFooter":"GroupTable_deleteModalFooter__38V4h"};